import { useRef, useEffect } from 'react';

/**
 * https://github.com/akiran/react-slick/issues/1240#issuecomment-1180985599
 * Disable window scrolling while swiping horizontally
 * @param ref HTML element
 * @param dragThreshold indicates that the user needs to swipe horizontally a greater distance before vertical scrolling is disabled.
 */ function usePreventVerticalScroll(ref, dragThreshold = 5) {
    const firstClientX = useRef(0);
    const clientX = useRef(0);
    useEffect(()=>{
        const preventTouch = (e)=>{
            clientX.current = e.touches[0].clientX - firstClientX.current;
            // Vertical scrolling does not work when you start swiping horizontally.
            if (Math.abs(clientX.current) > dragThreshold) {
                e.preventDefault();
                return false;
            }
            return true;
        };
        const touchStart = (e)=>{
            firstClientX.current = e.touches[0].clientX;
        };
        const element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (element) {
            element.addEventListener('touchstart', touchStart);
            element.addEventListener('touchmove', preventTouch, {
                passive: false
            });
        }
        return ()=>{
            if (element) {
                element.removeEventListener('touchstart', touchStart);
                element.removeEventListener('touchmove', preventTouch);
            }
        };
    });
}

export { usePreventVerticalScroll };
